import { useEffect } from "react";

export const DOMAIN = "https://achubimmobiliare.it";

function upsert(selector, create, apply) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  apply(el);
}

export default function Seo({ title, description, path, image, noindex = false }) {
  useEffect(() => {
    document.title = title;
    const url = `${DOMAIN}${path}`;
    const img = image ? `${DOMAIN}${image}` : null;

    upsert('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.rel = "canonical";
      return l;
    }, (el) => { el.href = url; });

    upsert('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.name = "description";
      return m;
    }, (el) => { el.content = description; });

    upsert('meta[name="robots"]', () => {
      const m = document.createElement("meta");
      m.name = "robots";
      return m;
    }, (el) => {
      el.content = noindex
        ? "noindex, nofollow"
        : "index, follow, max-image-preview:large, max-snippet:-1";
    });

    const og = [["og:title", title], ["og:description", description], ["og:url", url]];
    if (img) og.push(["og:image", img]);
    for (const [property, content] of og) {
      upsert(`meta[property="${property}"]`, () => {
        const m = document.createElement("meta");
        m.setAttribute("property", property);
        return m;
      }, (el) => { el.content = content; });
    }

    const tw = [["twitter:title", title], ["twitter:description", description]];
    if (img) tw.push(["twitter:image", img]);
    for (const [name, content] of tw) {
      upsert(`meta[name="${name}"]`, () => {
        const m = document.createElement("meta");
        m.name = name;
        return m;
      }, (el) => { el.content = content; });
    }
  }, [title, description, path, image, noindex]);

  return null;
}
